import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';


export function CreateTours(store, eventObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
   
    return PnkAjax(store).Post('tours/json/').ExtraData(eventObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
   
   
}

export function GetToursList(store, successFunc) {
    //  alert(localStorage.getItem('current_user_login_token'))
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('tours/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

export function UpdateTourDetails(store, tour_id, editObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Put('tour/json/' + tour_id).ExtraData(editObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

export function UpcomingTours(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('tours/json/1/3').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

export function GetTourDetails(store, tour_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('tour/json/' + tour_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

export function DeleteTour(store, tour_id, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Delete('tour/json/' + tour_id).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}


export function FavouriteTour(store, dataObj, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Post('favouritetour/json').ExtraData(dataObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}

export function GetFavouriteTour(store, successFunc) {
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    // if (!(store.GetData('userlist').length == 0)) {
    return PnkAjax(store).Get('favouritetour/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
    // }
    // else return HandleSuccessGetUserList(store.GetData('userlist'), store);
}